import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export const getImages = (imageName) => {
  const image = require(`../../assets/images/${imageName}`);
  return image;
}
export default function ScrollToTop() {
  const { pathname } = useLocation();
 useEffect(() => {
  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}, [pathname]);
  return null;
}


const makeImages = require.context('../../assets/images/logos', false, /\.png$/);

export const getMakeImages = (imageMakeName) => {
  try {
    return makeImages(`./${imageMakeName}`);
  } catch (err) {
    // If image not found, return fallback
    return makeImages('./mclaren-logo.png');
  }
};

export const teamImages = require.context('../../assets/images/team', false, /\.(png|jpe?g|svg)$/);